<div class="holder">
    <div class="left">
        <div class="header">
            <mat-slide-toggle>Show fields </mat-slide-toggle>

            <div class="actions">
                <button mat-icon-button ><mat-icon>zoom_in</mat-icon></button>
                <button mat-icon-button ><mat-icon>zoom_out</mat-icon></button>
            </div>
            <div class="page">
                Page
                <input type="text" value="2" > / 44
            </div>

        </div>
        <div class="thumbChart">
            <div class="thumbs">
                
                <div class="thumb" *ngFor="let thumb of thumbs" >
                    <div class="thumbnail">
                        <img [src]="thumb.src" alt="" >
                    </div>
                    <span>{{thumb.pageNumber}}</span>
                </div>

            </div>
            <div class="chart">
                <div class="chartPreview">
                  <img src="../../../../../assets/images/1.jpg" alt="" >
                </div>
                <div class="chartPreview">
                  <img src="../../../../../assets/images/1.jpg" alt="" >
                </div>
                <div class="chartPreview">
                  <img src="../../../../../assets/images/1.jpg" alt="" >
                </div>
                <div class="chartPreview">
                  <img src="../../../../../assets/images/1.jpg" alt="" >
                </div>
            </div>
        </div>
        
    </div>
    <div class="right">
        <div class="tabs">
            <ul>
                <ng-container *ngFor="let nav of navbar; let i = index">
                <li [ngClass]="{'active': nav == currentNavigation}"
                (click)="navigation(nav)"
                >
                        {{nav}}
                </li>
                </ng-container>
            </ul>
        </div>
        <div class="coding">
            
                <div class="bindFields">

                    <div class="coreSelectionHolder">
                      
                      <!-- <div class="coreChange" *ngIf="!toggleChangeCore">
                        <div class="selectedCore">
                          <h3>{{name}}</h3>
                          <p>{{email}}</p>
                        </div>
                  
                        <div class="">
                          <button mat-stroked-button color="primary" (click)="ChangeCore()">Change</button>
                        </div>
                      </div> -->
                      <!-- <div class="forChange" *ngIf="toggleChangeCore"> -->
                      <div class="forChange">
                        <div class="blockSelection">
                          <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCCC($event)">
                            <mat-radio-button value="Core" [checked]="checkedAttachCore">{{CoreShowName}}</mat-radio-button>
                            <mat-radio-button value="Contact" [checked]="checkedAttachContact">{{ContactShowName}}</mat-radio-button>
                            <mat-radio-button value="Company" [checked]="checkedAttachCompany">{{CompanyShowName}}</mat-radio-button>
                          </mat-radio-group>
                        </div>
                        
                      
                        <div class="autoComplete" *ngIf="ShowAttchedToCore || ShowAttchedToContact || ShowAttchedToCompany" >
                          <ng-container class="" *ngIf="ShowAttchedToCore">
                            <mat-form-field appearance="outline" style="position: relative;">
                              <mat-label>Search {{CoreShowName}}</mat-label>
                              <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                                (input)="searchCore($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                              <mat-autocomplete #auto="matAutocomplete" class="autooooo" >
                                <ng-container *ngFor="let core of attachedToCoreList">
                                  <mat-option (click)="attchedToCoreSelected(core)" [ngClass]="{'createNew': core.name == 'Create New'}" 
                                  [value]="core.name">
                                  <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                                    <div class="userpic">
                                      <img *ngIf="core.imageUrl!='' " src="{{core.imageUrl}}" alt="">
                                      <span class="username" *ngIf="core.imageUrl==''" class="username">
                                        {{core.shortName}}
                                      </span>
                                    </div>
                                    <div class="info" >
                                      <p> {{ core.name }}</p>
                                      <p class="email">{{ core.email }}</p>
                                    </div>
                                  </span>
                                </mat-option>
                                </ng-container>
                           
                              </mat-autocomplete>
                        
                            </mat-form-field>
                            <ul class="selectedlist" *ngFor="let core of attachedToSelectedCore">
                              <li>
                                <div class="userndetail">
                                  <div class="userpic">
                                    <img *ngIf="core.img!=''" src="{{core.img}}" alt="">
                                    <span *ngIf="core.img==''" class="username">
                                      {{core.shortName}}
                                    </span>
                                  </div>
                                  <div class="details">
                                    <h4>{{core.name}}</h4>
                                    <p>{{core.email}}</p>
                                  </div>
                                  <div class="opt">
                                    <button mat-icon-button>
                                      <mat-icon (click)="attchedToRemoveCore(core)">cancel</mat-icon>
                                    </button>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                    
                          <ng-container class="" *ngIf="ShowAttchedToContact">
                            <mat-form-field appearance="outline" style="position: relative;">
                              <mat-label>Search {{ContactShowName}}</mat-label>
                              <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                                (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                              <mat-autocomplete #auto="matAutocomplete">
                                <mat-option (click)="attchedToContactSelected(contact)"
                                  *ngFor="let contact of attachedToContactList" [value]="contact.name">
                                  <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                                    <div class="userpic">
                                      <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                                      <span class="username" *ngIf="contact.imageUrl==''" class="username">
                                        {{contact.shortName}}
                                      </span>
                                    </div>
                                    <div class="info">
                                      <p> {{ contact.name }}</p>
                                      <p class="email">{{ contact.email }}</p>
                                    </div>
                                  </span>
                                </mat-option>
                              </mat-autocomplete>
                        
                            </mat-form-field>
                            <ul class="selectedlist" *ngFor="let contact of attachedToSelectedContact">
                              <li *ngIf="!contact.isDeleted">
                                <div class="userndetail">
                                  <div class="userpic">
                                    <img *ngIf="contact.img!=''" src="{{contact.img}}" alt="">
                                    <span *ngIf="contact.img==''" class="username">
                                      {{contact.shortName}}
                                    </span>
                                  </div>
                                  <div class="details">
                                    <h4>{{contact.name}}</h4>
                                    <p>{{contact.email}}</p>
                                  </div>
                                  <div class="opt">
                                    <button mat-icon-button>
                                      <mat-icon (click)="attchedToRemoveContact(contact)">cancel</mat-icon>
                                    </button>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        
                          <ng-container class="" *ngIf="ShowAttchedToCompany">
                            <mat-form-field appearance="outline"  style="position: relative;">
                              <mat-label>Search {{CompanyShowName}}</mat-label>
                              <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                                (input)="searchCompany($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                              <mat-autocomplete #auto="matAutocomplete">
                                <mat-option (click)="attchedToCompanySelected(company)"
                                  *ngFor="let company of attachedToCompanyList" [value]="company.name">
                                  <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                                    <div class="userpic">
                                      <img *ngIf="company.imageUrl!=''" src="{{company.imageUrl}}" alt="">
                                      <span class="username" *ngIf="company.imageUrl==''" class="username">
                                        {{company.shortName}}
                                      </span>
                                    </div>
                                    <div class="info">
                                      <p> {{ company.name }}</p>
                                      <p class="email">{{ company.email }}</p>
                                    </div>
                                  </span>
                                </mat-option>
                              </mat-autocomplete>
                        
                            </mat-form-field>
                            <ul class="selectedlist" *ngFor="let company of attachedToSelectedCompany">
                              <li *ngIf="!company.isDeleted">
                                <div class="userndetail">
                                  <div class="userpic">
                                    <img *ngIf="company.img!=''" src="{{company.img}}" alt="">
                                    <span *ngIf="company.img==''" class="username">
                                      {{company.shortName}}
                                    </span>
                                  </div>
                                  <div class="details">
                                    <h4>{{company.name}}</h4>
                                    <p>{{company.email}}</p>
                                  </div>
                                  <div class="opt">
                                    <button mat-icon-button>
                                      <mat-icon (click)="attchedToRemoveCompany(company)">cancel</mat-icon>
                                    </button>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                        </div>
                      </div>
                      
                    </div>
                
                    
                  
                
                  </div>
             
             <button mat-icon-button color="primary" (click)="openSystemFields(SystemFields)">
                 <mat-icon>add</mat-icon>
              </button>

            <div class="card">
              
              <div class="ocrFiled" >
                Setup Driver at first time

              <button mat-stroked-button class="aiBtn" >
                <mat-icon>arrow_downward</mat-icon>
              </button>
              </div>


              <div class="ocrChooseField" *ngFor="let item of CustomFeildsList;let i = index">
                <!-- <mat-form-field class="width" > -->
                  {{item.fieldName}}
                  <!-- <input matInput placeholder="Choose system fields"/> -->
                  <!-- <mat-autocomplete #auto="matAutocomplete">
                    <mat-option 
                      value="test">
                      <span>Setup Driver at first time</span>
                    </mat-option>
                  </mat-autocomplete> -->
                <!-- </mat-form-field>            -->
  
                <div class="aiBtn">
                  <!-- <button  mat-stroked-button class="aiBtn" 
                >AI</button> -->
                </div>
  
                <mat-form-field>
                  <input matInput value="" placeholder=""/>
                </mat-form-field>   
              </div>  
              

            </div>
            
            <!-- <div class="card">
                
            </div>
            <div class="card">
                
            </div>
            <div class="card">
                
            </div>
            <div class="card">
                
            </div>
            <div class="card">
                
            </div>
            <div class="card">
                
            </div> -->

        </div>
    </div>
</div>

<ng-template #SystemFields>
    <h2 mat-dialog-title>
      AI Field Mapping
      <button mat-icon-button (click)="closeAI()"><mat-icon>close</mat-icon></button>
    </h2>
    <mat-dialog-content class="mat-typography">
          
      <div class="filedBlock">
        <h3>System Fields</h3>
        <div class="" *ngIf="systemFieldsAI.length>0">
          <div class="list" *ngFor="let item of systemFieldsAI;let i = index" >
                    
            <div class="listblock">
              <mat-checkbox color="primary" (change)="getCheckboxValues($event, item)">
                {{item.fieldName}}
              </mat-checkbox> 
            </div>
          </div>
        </div>
        <div *ngIf="systemFieldsAI.length==0">
          <p class="notFound" > No Record Found</p>
        </div>
      </div>
  
      
    
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="closeAI()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="ShowAddCustomFeildButton==false" 
       (click)="AddSystemFields()">Add</button> 
    </mat-dialog-actions>
  </ng-template>

  <app-loader></app-loader>